import React from 'react';
import {useHistory} from 'react-router-dom';
import Icon from '../Icon';

const Back = ({isClose}) => {
  const history = useHistory();

  return (
    <button className="btn btn-back bg-white border btn-light" onClick={() => history.goBack()}>
      <div className="row gx-1">
        <span className="col-auto position-relative" style={{bottom: 2}}>
          <Icon name={isClose ? 'times' : 'chevron-left'} size={14} />
        </span>
        <span className="font-3 ms-2 col-auto">{isClose ? 'Закрыть' : 'Вернуться назад'}</span>
      </div>
    </button>
  );
};

export default Back;
